import * as React from "react";
import { css } from "@emotion/react";
import f from "@/module/Utils/emotion";
import v from "@/module/Utils/variable";
import Util from "@/module/Utils/Util";

const SeeUBBAnimation: React.FC = () => {
  //Initialize
  const [startAnimeFlag, setStartAnimeFlag] = React.useState(false);

  // Styles
  const baseSvgAnimation = (delay: number = 0) => {
    return css({
      g: {
        transform: "translateY(100%)",
        opacity: 0,
      },
      "&.is-animate": {
        g: {
          transform: "translateY(0%)",
          opacity: 1,
        },
        "g:nth-of-type(1)": {
          transition: `transform 1s ${delay + 0}s ease, opacity 1s ${
            delay + 0
          }s ease`,
        },
        "g:nth-of-type(2)": {
          transition: `transform 1s ${delay + 0.2}s ease, opacity 1s ${
            delay + 0.2
          }s ease`,
        },
        "g:nth-of-type(3)": {
          transition: `transform 1s ${delay + 0.4}s ease, opacity 1s ${
            delay + 0.4
          }s ease`,
        },
        "g:nth-of-type(4)": {
          transition: `transform 1s ${delay + 0.6}s ease, opacity 1s ${
            delay + 0.6
          }s ease`,
        },
      },
    });
  };

  const upperSvgWrapStyle = css(baseSvgAnimation(0), {
    overflow: "hidden",
    width: `90%`,
  });

  const lowerSvgWrapStyle = css(baseSvgAnimation(0.2), {
    overflow: "hidden",
    [f.sp()]: {
      marginTop: f.vw(25, v.spWidth),
    },
    [f.pc()]: {
      marginTop: f.vw(28),
    },
  });

  //LifeCycle
  React.useEffect(() => {
    Util.sleep(v.pageTransition).then(() => {
      setStartAnimeFlag(true);
    });
  });

  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 225.132 87.072"
        css={upperSvgWrapStyle}
        className={startAnimeFlag ? "is-animate" : ""}
      >
        <g>
          <path
            d="M212.448,519.555c-11.127,0-27.705-4.439-36.153-15.666l2.615-6.68c8.148,11.118,23.821,16.1,33.538,16.1,10.187,0,20.79-3.758,20.79-18.212,0-8.88-6.538-16.525-26.222-19.661-18.692-2.978-26.1-9.154-27.886-17.229-1.443-6.54,1.262-19.415,17.617-24.009,19.785-5.557,40.94,3.585,47.61,10.671l-2.4,5.744c-16.066-16.105-42.975-14.576-47.779,1.733-2.35,7.974,2.518,15.866,13.181,18.139,6.447,1.375,16.219,2.526,16.219,2.526,14.966,2.552,24.384,10.66,24.384,21.8C247.965,509.842,233.11,519.555,212.448,519.555Z"
            transform="translate(-176.295 -432.483)"
            fill="#C9161F"
          />
        </g>
        <g>
          <path
            d="M365.324,511.621V475.883h45.123v-6.135H365.324v-31.1h49.132l.016-6.1H350.621v85.2h64.063v-6.123Z"
            transform="translate(-266.216 -432.511)"
            fill="#C9161F"
          />
        </g>
        <g>
          <path
            d="M522.216,511.621V475.883h45.124v-6.135H522.216v-31.1h49.133l.015-6.1h-63.85v85.2h64.063v-6.123Z"
            transform="translate(-346.444 -432.511)"
            fill="#C9161F"
          />
        </g>
      </svg>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 249.507 81.759"
        css={lowerSvgWrapStyle}
        className={startAnimeFlag ? "is-animate" : ""}
      >
        <g>
          <path
            d="M24.75-72.516H38.186v51.875a26.257,26.257,0,0,0,1.747,9.61,23.459,23.459,0,0,0,5,7.863A23.584,23.584,0,0,0,52.8,2.164,26.021,26.021,0,0,0,63.069,4.122a25.961,25.961,0,0,0,10.3-1.958,23.326,23.326,0,0,0,7.8-5.332,23.308,23.308,0,0,0,4.94-7.863,26.666,26.666,0,0,0,1.717-9.61V-72.516h5.9v51.875A33.338,33.338,0,0,1,91.748-9.073,24.816,24.816,0,0,1,85.512.417,30.258,30.258,0,0,1,74.637,6.863a47.211,47.211,0,0,1-15.906,2.38A41.512,41.512,0,0,1,44.12,6.863,31.034,31.034,0,0,1,33.456.387a26.832,26.832,0,0,1-6.507-9.61A31.494,31.494,0,0,1,24.75-21Z"
            transform="translate(-24.75 72.516)"
            fill="#C9161F"
          />
        </g>
        <g>
          <path
            d="M110.211-72.516h32.173A45.6,45.6,0,0,1,154.1-71.1a29.886,29.886,0,0,1,9.158,4.007,19.147,19.147,0,0,1,5.935,6.206,15.5,15.5,0,0,1,2.109,7.953,23.9,23.9,0,0,1-.663,5.9,13.168,13.168,0,0,1-2.35,4.79,20.093,20.093,0,0,1-4.489,4.157,50.766,50.766,0,0,1-7.079,4.007v.241a27.91,27.91,0,0,1,7.712,2.289,20.186,20.186,0,0,1,5.874,4.127,17.512,17.512,0,0,1,3.766,5.844,19.693,19.693,0,0,1,1.326,7.32,18.786,18.786,0,0,1-1.958,8.465,20.339,20.339,0,0,1-5.6,6.868,27.685,27.685,0,0,1-8.8,4.609,36.956,36.956,0,0,1-11.538,1.687H110.211Zm13.436,35.969h17.111a20.817,20.817,0,0,0,7.17-1.145,15.46,15.46,0,0,0,5.3-3.163,13.123,13.123,0,0,0,3.284-4.82,16.23,16.23,0,0,0,1.115-6.055,14.943,14.943,0,0,0-1.326-6.356A12.642,12.642,0,0,0,152.175-63a20.367,20.367,0,0,0-7.109-3.133,42.816,42.816,0,0,0-10.333-1.084H123.646Zm0,38.078h14.52A40.852,40.852,0,0,0,148.319.417a21.131,21.131,0,0,0,7.109-3.133,12.734,12.734,0,0,0,4.157-4.85,14.184,14.184,0,0,0,1.356-6.206,20.141,20.141,0,0,0-1.2-7.049,13.661,13.661,0,0,0-3.946-5.633,19.831,19.831,0,0,0-7.17-3.766,36.823,36.823,0,0,0-10.875-1.386h-14.1Z"
            transform="translate(-25.203 72.516)"
            fill="#C9161F"
          />
        </g>
        <g>
          <path
            d="M110.211-72.516h32.173A45.6,45.6,0,0,1,154.1-71.1a29.886,29.886,0,0,1,9.158,4.007,19.147,19.147,0,0,1,5.935,6.206,15.5,15.5,0,0,1,2.109,7.953,23.9,23.9,0,0,1-.663,5.9,13.168,13.168,0,0,1-2.35,4.79,20.093,20.093,0,0,1-4.489,4.157,50.766,50.766,0,0,1-7.079,4.007v.241a27.91,27.91,0,0,1,7.712,2.289,20.186,20.186,0,0,1,5.874,4.127,17.512,17.512,0,0,1,3.766,5.844,19.693,19.693,0,0,1,1.326,7.32,18.786,18.786,0,0,1-1.958,8.465,20.339,20.339,0,0,1-5.6,6.868,27.685,27.685,0,0,1-8.8,4.609,36.956,36.956,0,0,1-11.538,1.687H110.211Zm13.436,35.969h17.111a20.817,20.817,0,0,0,7.17-1.145,15.46,15.46,0,0,0,5.3-3.163,13.123,13.123,0,0,0,3.284-4.82,16.23,16.23,0,0,0,1.115-6.055,14.943,14.943,0,0,0-1.326-6.356A12.642,12.642,0,0,0,152.175-63a20.367,20.367,0,0,0-7.109-3.133,42.816,42.816,0,0,0-10.333-1.084H123.646Zm0,38.078h14.52A40.852,40.852,0,0,0,148.319.417a21.131,21.131,0,0,0,7.109-3.133,12.734,12.734,0,0,0,4.157-4.85,14.184,14.184,0,0,0,1.356-6.206,20.141,20.141,0,0,0-1.2-7.049,13.661,13.661,0,0,0-3.946-5.633,19.831,19.831,0,0,0-7.17-3.766,36.823,36.823,0,0,0-10.875-1.386h-14.1Z"
            transform="translate(50.857 72.516)"
            fill="#C9161F"
          />
        </g>
        <g>
          <path
            d="M645.383,533.79a8.249,8.249,0,1,1-8.249-8.249,8.249,8.249,0,0,1,8.249,8.249"
            transform="translate(-395.877 -462.148)"
            fill="#C9161F"
          />
        </g>
      </svg>
    </>
  );
};

export default SeeUBBAnimation;
